import * as api from './../../http'

export const ActionSetUtils = async ({ commit }) => {
  const utils = await api.http.get('dash/coordinator/utils').then((response) => response.body)
  commit('SET_utils', utils)
}
